import React, { useState } from 'react'

import { useColumns } from './columns'
import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getExpandedRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../lib/ui/table'
import { useCoachDashboard } from '../../CoachDashboardProvider'
import { cn } from '../../../../lib/utils'

export function UpcomingEventDataTable() {
  const { upcomingEvents } = useCoachDashboard()
  const [expanded, setExpanded] = useState({})
  const [globalFilter, setGlobalFilter] = useState('')
  const columns = useColumns()
  const table = useReactTable({
    debugTable: true,
    data: upcomingEvents || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getRowCanExpand: () => true,
    state: {
      expanded,
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: 'includesString',
    enableMultiSorting: true,
    onExpandedChange: setExpanded,
    getExpandedRowModel: getExpandedRowModel(),
  })

  return (
    <>
      <div className="rounded-2xl border border-alto-200">
        <Table tableClass="rounded-2xl">
          <TableHeader className="rounded-2xl bg-intoo-green-coachcta">
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow
                key={`${headerGroup.id}-header_group`}
                className="border-alto-200 bg-intoo-green-coachcta p-4 text-white  hover:bg-intoo-green-coachcta sm:px-8 sm:py-6"
              >
                {headerGroup.headers.map((header) => {
                  return (
                    <TableHead
                      key={`${header.id}-header`}
                      className="job-search-table-header h-6 pl-0 text-sm font-bold text-foreground data-[col-id=status]:w-[96px] sm:h-12 sm:px-4 data-[col-id=status]:sm:w-[120px]"
                      data-col-id={header.column.id}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                    </TableHead>
                  )
                })}
              </TableRow>
            ))}
          </TableHeader>
          <TableBody>
            {table.getRowModel().rows?.length ? (
              table
                .getRowModel()
                .rows.map((row, index) => (
                  <DataTableRow
                    key={`${row.id}-table_row`}
                    row={row}
                    index={index}
                  />
                ))
            ) : (
              <TableRow className="p-4 sm:px-8 sm:py-6">
                <TableCell colSpan={columns.length + 2} className="h-24">
                  <div className="flex flex-col items-center justify-center">
                    <div className="max-w-96 text-center">
                      <p>You have no upcoming webinars or workshops.</p>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </>
  )
}

const DataTableRow = ({ row, ...props }) => {
  const { index } = props
  return (
    <>
      <TableRow
        fred={5}
        className={
          (cn('border-alto-200'),
          index % 2 === 1
            ? 'bg-alto-50 hover:bg-alto-50'
            : '!hover:bg-white !bg-white')
        }
        {...props}
      >
        {row.getVisibleCells().map((cell) => (
          <TableCell
            key={`${row.id}_${cell.id}`}
            className="pb-2 pl-0 pr-0 pt-3 sm:p-4 sm:pr-1"
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableCell>
        ))}
      </TableRow>
    </>
  )
}
